import axios from "axios";
import { JurisdictionService } from "@services";
import utils from "@utils";

let cancelJurisdictions;

/**
 * Searches for jurisdictions whose name contains the `inputValue` parameter and provides the results as a parameter of `callback`
 * @param {String} inputValue The value to use when searching for jurisdictions
 * @param {(results:Array) => void} callback A function that handles the returned results from the jurisdicton search
 */
const loadJurisdictions = (inputValue, callback) => {
	if (inputValue.length < 3) {
		callback([]);
		return;
	}

	// If there is a request already running, abort it and start a new one
	if (cancelJurisdictions) cancelJurisdictions();

	JurisdictionService.getAll({
		scope: "Name",
		search: inputValue,
		getCancelToken: c => {
			cancelJurisdictions = c;
		},
	})
		.then(response => {
			cancelJurisdictions = undefined;

			callback(
				response.data.map(option => ({
					value: option.Id,
					label: `${option.Name}, ${option.County} County ${option.StateName}`,
				})),
			);
		})
		.catch(error => {
			if (!axios.isCancel(error)) {
				utils.notify({
					type: "error",
					message: "Error loading jurisdictions",
				});
				callback([]);
			}
		});
};

export default {
	loadJurisdictions,
};
